<template>
  <div class="row">
    <div class="col-sm-6 col-sm-offset-3">
      <div class="card-box">
        <h4 class="header-title m-t-0 m-b-30">Notifications</h4>
        <div class="row m-t-20">
          <div class="col-xs-8">
            <h6 class="m-0">Notification Bureau</h6>
            <p class="text-muted">
              <small>Recevoir une notification sur le bureau au lieu d'un popup dans l'interface.</small>
            </p>
          </div>
          <div class="col-xs-4 m-t-10">
            <el-switch :disabled="!user.meta.deviceId" v-model="notifications_desktop" on-text="" off-text=""
                       class="pull-right"></el-switch>
          </div>
          <div class="col-md-12">
            <div class="alert alert-warning" style="clear: both; text-align: center;" v-if="!user.meta.deviceId">
              Vous devez autoriser votre poste à recevoir des notifications bureau.
            </div>
          </div>
        </div>

        <div class="row m-t-20">
          <div class="col-xs-8">
            <h6 class="m-0">Pré-rappel de rendez-vous</h6>
            <p class="text-muted">
              <small>Recevoir des pré-notifications avant l'heure des rendez-vous.</small>
            </p>
          </div>
          <div class="col-xs-4 m-t-10">
            <div class="row">
              <div class="col-md-12" v-for="(notification, index) in preferences.reminders.notifications"
                   :index="index">
                <el-slider v-model="preferences.reminders.notifications[index]"
                           v-on:change="emptyRemindersNotifications" :step="5" :min="0" :max="60"
                           :format-tooltip="sliderFormatMinutes"></el-slider>
              </div>
              <div class="col-md-12">
                <el-button class="pull-right" v-on:click="preferences.reminders.notifications.push(0)" type="success"
                           :plain="true" icon="plus" size="small"></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-box">
        <h4 class="header-title m-t-0">Affichage</h4>

        <el-tabs v-model="tabs.active">
          <el-tab-pane label="Rappels" name="reminders">
            <div class="row">
              <div class="col-md-6">
                <div class="row m-t-20">
                  <div class="col-xs-6">
                    <h6 class="m-0">Rappels passés affichés</h6>
                    <p class="text-muted">
                      <small>Etendre l'affichage des rappels du jour et passés à plus de X jours.</small>
                    </p>
                  </div>
                  <div class="col-xs-6 m-t-10">
                    <el-slider v-model="preferences.reminders.show_since_days" :min="0" :max="180"
                               :format-tooltip="sliderFormatDays"></el-slider>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row m-t-20">
                  <div class="col-xs-6">
                    <h6 class="m-0">Calendrier des RDV</h6>
                    <p class="text-muted">
                      <small>Changer le format d'affichage des rendez-vous.</small>
                    </p>
                  </div>
                  <div class="col-xs-6 m-t-10">
                    <el-select v-model="preferences.reminders.meeting_display_mode" placeholder="Select">
                      <el-option label="Par mois" value="monthly"></el-option>
                      <el-option label="Par semaine" value="weekly"></el-option>
                      <el-option label="En liste" value="list"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Liste de tâches" name="task_lists">
            <div class="row">
              <div class="col-md-6">
                <div class="row m-t-20">
                  <div class="col-xs-6">
                    <h6 class="m-0">Mode d'intégration</h6>
                    <p class="text-muted">
                      <small>Choix de l'ajustement du corps l'interface.</small>
                    </p>
                  </div>
                  <div class="col-xs-6 m-t-10">
                    <el-select v-model="preferences.task_lists.display_mode" placeholder="Select">
                      <el-option label="Par dessus" value="floating"></el-option>
                      <el-option label="Intégré" value="into"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row m-t-20">
                  <div class="col-xs-6">
                    <h6 class="m-0">Toujours ouvert</h6>
                    <p class="text-muted">
                      <small>Bloquer le panneau à droite et le laisser ouvert.</small>
                    </p>
                  </div>
                  <div class="col-xs-6 m-t-10">
                    <el-switch v-model="preferences.task_lists.always_displayed" on-text="" off-text=""
                               class="pull-right"></el-switch>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-button type="primary" class="waves-effect waves-light pull-right" v-on:click="save">
        Enregistrer
      </el-button>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import nexus from '@db2b/nexus-js'

  let $ = window.$

  export default {
    name: 'preferences',
    data () {
      return {
        tabs: {
          active: 'reminders'
        },
        preferences: Object.assign({}, this.$store.getters['user_preferences/current'].payload)
      }
    },
    computed: {
      user: function () {
        return this.$store.getters['users/current']
      },
      notifications_desktop: {
        get: function () {
          return this.preferences.notifications.type === 'desktop'
        },
        set: function (value) {
          if (value) {
            this.preferences.notifications.type = 'desktop'
          } else {
            this.preferences.notifications.type = 'web'
          }
        }
      }
    },
    methods: {
      sliderFormatMinutes (value) {
        return value + ' minute(s)'
      },
      sliderFormatDays (value) {
        return value + ' jour(s)'
      },
      emptyRemindersNotifications () {
        this.preferences.reminders.notifications = this.preferences.reminders.notifications.filter(item => { return item > 0 })
      },
      save () {
        let self = this

        if (this.preferences.task_lists.always_displayed) {
          $('#wrapper').addClass('right-bar-enabled')
        } else {
          $('#wrapper').removeClass('right-bar-enabled')
        }

        // Add the device id into notifications devices and make sure it is unique
        if (this.$store.getters['users/current'].meta.deviceId) {
          this.preferences.notifications.devices.push(this.$store.getters['users/current'].meta.deviceId)
          this.preferences.notifications.devices = _.uniq(this.preferences.notifications.devices)
        }

        // Sort the reminders notifications into the right way
        this.preferences.reminders.notifications.sort((a, b) => {
          return parseInt(a) < parseInt(b)
        })

        this.$store.dispatch('user_preferences/update', {preferences: this.preferences})
          .then(() => {
            self.$message.success('Les préférences ont été enregistrées.')
          })
      }
    },
    created () {
      let self = this

      this.$store.commit('app/ui/changeTitle', 'Mon compte')
      this.$store.commit('app/ui/changeSubtitle', 'Configuration de votre compte.')

      this.$watch(() => {
        return self.$store.getters['user_preferences/current'].payload
      }, (preferences) => {
        self.preferences = Object.assign({}, self.preferences, preferences)
      })
    },
    activated () {
      this.$store.commit('app/ui/changeTitle', 'Mon compte')
      this.$store.commit('app/ui/changeSubtitle', 'Configuration de votre compte.')
    }
  }
</script>



// WEBPACK FOOTER //
// Preferences.vue?22a9fcf6